import DownpaymentSupportedAssociations from "./DownpaymentSupportedAssociations.vue"

export default {
    install(Vue) {
        Vue.component("DownpaymentSupportedAssociations", DownpaymentSupportedAssociations)
    },
}
